// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".business-select .box[data-v-62626e34]{width:1rem;display:inline-block}@media (min-width:992px){[data-v-62626e34] #nav-item-business ul.dropdown-menu{overflow:hidden;overflow-y:auto;max-height:calc(100vh - 100px)}}", ""]);
// Exports
module.exports = exports;
